import "./Questionary.css";
import React, { useState } from "react";

export default function Questionary() {
  const [step, setStep] = useState(0);

  function nextStep() {
    setStep(step + 1);
  }

  function prevStep() {
    setStep(step - 1);
  }

  if (step === 0) {
    return (
      <div className="Questionary">
        <main>
          <h2>How can I help you?</h2>
          <button>Weight / Fat Loss</button>
          <br />
          <button>Muscle Gain</button>
          <br />
          <button>Healthy Lifestyle</button>
          <br />
          <button>Tone and Shape</button>
        </main>
        <div>
          <button onClick={nextStep}>Next →</button>
        </div>
      </div>
    );
  } else if (step === 1) {
    return (
      <div className="Questionary">
        <main>
          <h2>What has previously held you back from your goals?</h2>
          <label>
            <input className="input" placeholder="Write your text here..." />
          </label>
        </main>
        <div className="previous-next">
          <button className="prev" onClick={prevStep}>
            ← Previous
          </button>
          <button onClick={nextStep}>Next →</button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="Questionary">
        <main>
          <h2>Are you ready to invest in yourself?</h2>
          <button>Yes</button>
          <button>Sure</button>
        </main>
        <div className="previous-next">
          <button className="prev" onClick={prevStep}>
            ← Previous
          </button>
          <a href="#plans">
            <button onClick={nextStep}>Next →</button>
          </a>
        </div>
      </div>
    );
  }
}
